module.exports = __webpack_public_path__ + "static/media/eh.7af60670.svg";